// extracted by mini-css-extract-plugin
module.exports = {"buttons":"ConfirmModal_buttons__2Z5I_","alertIcon":"ConfirmModal_alertIcon__N9ek0"};